import { MockupWithImage } from '@wix/ambassador-suppliershub-marketplace-mockups-v1-mockup/types';

const productsWithMediaToMockups = (productIds: string[], mediaUrl: string): MockupWithImage[] => {
  return productIds.map((productId) => ({
    mockup: {
      productId,
    },
    image: {
      url: mediaUrl,
    },
  }));
};

export const mapperUtils = {
  productsWithMediaToMockups,
};
